<template>
  <b-col v-show="activeTab == tabName" xl="8" lg="8" sm="12" class="mb-3">
    <div class="clearfix">
      <div class="float-start">
        <h4 class="card-title">
          {{ title }}
        </h4>
      </div>
      <div class="float-end d-flex">
        <a v-if="!selectedAll" @click="handleSelectAll(true)">
          <h6 class="text-primary">
            {{ `${$t('global.action.activate')} ${$t('global.filter.all')}` }}
          </h6>
        </a>
        <a v-else @click="handleSelectAll(false)">
          <h6 class="text-primary">
            {{ `${$t('global.action.nonactivate')} ${$t('global.filter.all')}` }}
          </h6>
        </a>
      </div>
    </div>
    <b-skeleton-wrapper :loading="!rendered">
      <template #loading>
        <b-card>
          <b-skeleton width="65%" height="300px" class="my-2" />
        </b-card>
      </template>
      <div class="mc-notification-tab">
        <div v-for="item in items" :key="item.id">
          <b-form-checkbox
            v-if="item.scope == null ? true : item.scope"
            :checked="selectedIds[item.id]"
            @change="(event) => handleSelect(event, item)"
          >
            <label class="mx-2">
              {{ $t(item.title) }}
              <a v-if="item.hasSetting" @click="handleSetting(item.url)">
                <i class="mc-fa icon-outline_settings"></i>
              </a>
            </label>
          </b-form-checkbox>
        </div>
      </div>
    </b-skeleton-wrapper>
  </b-col>
</template>

<script>
export default {
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    tabName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    handleSetting: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedAlert: [],
      selectedIds: {},
      selectedAll: false,
      selectedIdsLength: 0,
      rendered: true,
    }
  },
  computed: {
    screenWidth() {
      return window.innerWidth
    },
  },
  mounted() {
    this.selectedIdsLength = this.selected.length
    if (this.selectedIdsLength > 0) {
      this.initData()
    }
  },
  methods: {
    initData() {
      this.rendered = false
      this.handleUnselectAll()
      const data = this.items.filter((item) => (item.scope == null ? true : item.scope))
      this.selected.forEach((id) => {
        this.selectedIds[id] = true
      })
      this.selectedIdsLength = this.selected.length
      this.selectedAll = data.length === this.selectedIdsLength
      const selectedObj = data.filter((obj) => this.selectedIds[obj.id])
      this.selectedAlert = selectedObj.flatMap((item) => item.alertCode)
      this.$emit('handleAlertCode', this.selectedAlert)
      setTimeout(() => {
        this.rendered = true
      }, 400)
    },
    handleSelect(checked, item) {
      const data = this.items.filter((item) => (item.scope == null ? true : item.scope))
      this.selectedIds = { ...this.selectedIds, [item.id]: checked }
      if (checked) {
        this.selectedIdsLength += 1
        this.selectedAll = data.length === this.selectedIdsLength
      } else {
        this.selectedIdsLength -= 1
        this.selectedAll = false
      }
      const selectedObj = data.filter((obj) => this.selectedIds[obj.id])
      this.selectedAlert = selectedObj.flatMap((item) => item.alertCode)
      this.$emit('handleAlertCode', this.selectedAlert)
    },
    handleSelectAll(state) {
      const ids = this.items
        .filter((item) => (item.scope == null ? true : item.scope))
        .map((item) => item.id)
      if (state) {
        this.selectedIds = Object.fromEntries(ids.map((key) => [key, true]))
        this.selectedIdsLength = ids.length
        this.selectedAlert = this.items
          .filter((item) => (item.scope == null ? true : item.scope))
          .flatMap((item) => item.alertCode)
        this.selectedAll = true
      } else {
        this.handleUnselectAll()
      }
      this.$emit('handleAlertCode', this.selectedAlert)
    },
    handleUnselectAll() {
      this.selectedIds = {}
      this.selectedAlert = []
      this.selectedIdsLength = 0
      this.selectedAll = false
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-notification-tab {
  height: 360px;
  padding: 1rem;
  border: 1px solid $teal-100;
  border-radius: 0.25rem;
  background: $white;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  overflow: hidden;
  position: relative;

  .separator {
    &:before {
      content: '';
      width: 1px;
      height: calc(100% - 2rem);
      top: 1rem;
      left: 48%;
      position: absolute;
      background-color: $teal-100;
    }
  }

  .custom-checkbox {
    width: 360px;
    box-sizing: border-box;
    padding-right: 2rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .mc-fa {
    &:before {
      color: $mep-primary;
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 992px) {
    overflow-y: auto;
    flex-wrap: nowrap;
  }

  @media only screen and (max-width: 1280px) {
    .separator {
      &:before {
        left: 46%;
      }
      .custom-checkbox {
        width: 310px;
        text-overflow: clip;
      }
    }
  }
}
</style>
